// ignore-string-externalization
import React from 'react';
import { createWidget } from '@typeform/embed';
import { spacer8 } from '@spotify-internal/encore-foundation/web';
import styled from 'styled-components';
import { useCurrentUser } from '../../@mrkt/useCurrentUser';
import { Wait } from '../Layout';
import { jsx as _jsx } from "react/jsx-runtime";
var TypeformContainer = styled.div.withConfig({
  displayName: "TypeformTemplate__TypeformContainer",
  componentId: "sc-1ohh4ox-0"
})(["width:100%;height:100vh;.typeform-widget{width:100%;height:100%;iframe{width:100%;height:100%;border:none;overflow:hidden;border-radius:", ";}}"], spacer8);
export var TypeformTemplate = function TypeformTemplate(template) {
  var formId = template.formId;
  var user = useCurrentUser();
  var formRef = /*#__PURE__*/React.createRef();
  React.useEffect(function () {
    if (user && formId) {
      var _user$partnerIds;

      createWidget(formId, {
        container: formRef.current,
        hideHeaders: true,
        hideFooter: true,
        hidden: {
          partner_id: (user === null || user === void 0 ? void 0 : (_user$partnerIds = user.partnerIds) === null || _user$partnerIds === void 0 ? void 0 : _user$partnerIds.google) || 'unknown'
        }
      });
    }
  }, [user, formId, formRef]);
  return /*#__PURE__*/_jsx(TypeformContainer, {
    ref: formRef,
    children: !user && /*#__PURE__*/_jsx(Wait, {
      cover: true
    })
  });
};